export default __webpack_public_path__ + "static/media/bannersuscripcion.ee524c08.png";